import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import styled from 'styled-components';
import { Text } from 'foundations-components/components/Text';
import { isCanvasTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "Separator__Container",
  componentId: "sc-1kq23mv-0"
})(({
  theme
}) => {
  const borderColor = isCanvasTheme(theme) ? theme.color['border-core-default'] : theme.color['border-core-subtle-hover'];
  return {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.space['600'],
    '&::before, &::after': {
      content: '""',
      borderTop: `1px solid ${borderColor}`,
      margin: `0 ${theme.space['400']} 0 0`,
      flex: '1 0 20px'
    },
    '&::after': {
      margin: `0 0 0 ${theme.space['400']}`
    }
  };
});
const Separator = ({
  message
}) => {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(Container, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "span",
        color: "text-core-default",
        textAlign: "center",
        typography: "body-200",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: message
        })
      })
    })
  );
};
export default Separator;